export const CART_KEY = 'currentCart';
export const USER_SESSION_KEY = 'userSession';
